var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#32D74B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.5C13.9233 26.5 11.8932 25.8842 10.1665 24.7304C8.4398 23.5767 7.09399 21.9368 6.29927 20.0182C5.50455 18.0996 5.29661 15.9884 5.70176 13.9516C6.1069 11.9148 7.10693 10.0438 8.57538 8.57538C10.0438 7.10693 11.9148 6.1069 13.9516 5.70176C15.9884 5.29661 18.0996 5.50455 20.0182 6.29927C21.9368 7.09399 23.5767 8.4398 24.7304 10.1665C25.8842 11.8932 26.5 13.9233 26.5 16C26.5 18.7848 25.3938 21.4555 23.4246 23.4246C21.4555 25.3938 18.7848 26.5 16 26.5ZM16 7C14.22 7 12.4799 7.52785 10.9999 8.51678C9.51983 9.50571 8.36628 10.9113 7.68509 12.5559C7.0039 14.2004 6.82567 16.01 7.17294 17.7558C7.5202 19.5016 8.37737 21.1053 9.63604 22.364C10.8947 23.6226 12.4984 24.4798 14.2442 24.8271C15.99 25.1743 17.7996 24.9961 19.4442 24.3149C21.0887 23.6337 22.4943 22.4802 23.4832 21.0001C24.4722 19.5201 25 17.78 25 16C25 13.6131 24.0518 11.3239 22.364 9.63604C20.6761 7.94822 18.387 7 16 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4425 20.5L15.25 16.3075V9.25H16.75V15.685L20.5 19.4425L19.4425 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.bbd2f0e074efb655de3d880226bb16ec.svg";
export { ForwardRef as ReactComponent };